// The stored WebP copies of a captured screen (written by scripts/thumb-designs.mjs):
//   …/public/first-party/<app>/screens/a.png → …/public/first-party/thumbs/w400/<app>/screens/a.png.webp

export const THUMB_WIDTHS = [400, 800] as const;
type ThumbWidth = (typeof THUMB_WIDTHS)[number];

const BUCKET = '/storage/v1/object/public/first-party/';

/** The path inside the first-party bucket, or null for an image stored anywhere else. */
export function screenPath(url: string): string | null {
  const at = url.indexOf(BUCKET);
  if (at < 0) return null;
  const path = url.slice(at + BUCKET.length).split(/[?#]/)[0];
  return path && !path.startsWith('thumbs/') ? path : null;
}

export const thumbPath = (path: string, width: ThumbWidth) => `thumbs/w${width}/${path}.webp`;

/** The stored WebP copy of a captured screen, or null when the image has none. */
export function screenThumb(url: string, width: ThumbWidth): string | null {
  const path = screenPath(url);
  if (!path) return null;
  return `${url.slice(0, url.indexOf(BUCKET) + BUCKET.length)}${thumbPath(path, width)}`;
}
